/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const Logger = require("js-logger");
Logger.useDefaults();
const $ = require("jquery");

const defaultHandler = Logger.createDefaultHandler({
  formatter: function(messages, context) {
    var name = context.name ? context.name : "default";
    var prefix = "[" + name + "]";
    messages.unshift(prefix);
  }
});
Logger.setHandler(defaultHandler);

Logger.debug("environment: ", process.env.NODE_ENV);
if (process.env.NODE_ENV !== "development") {
  Logger.setLevel(Logger.OFF);
}

require("./bootstrap");
const checkboxes = require("./checkboxes");
const validations = require("./libraries/booking-validations/booking-validations");
const profileMediaForm = require("./libraries/booking-profile-media-form/booking-profile-media-form");
const upsalesForm = require("./libraries/booking-upsales-form/booking-upsales-form");
const tooltips = require("./libraries/booking-tooltips/booking-tooltips");
const imageUploader = require("./libraries/booking-image-uploader/booking-image-uploader");
const audioUploader = require("./libraries/booking-audio-uploader/booking-audio-uploader");
const videoUploader = require("./libraries/booking-video-uploader/booking-video-uploader");
const account = require("./libraries/booking-account/booking-account");
const horizontalSpinner = require("./libraries/booking-horizontal-spinner/booking-horizontal-spinner");
const priceAdjustment = require("./libraries/booking-price-adjustment/booking-price-adjustment");
const availabilityCalendar = require("./libraries/booking-availability-calendar/booking-availability-calendar");
const imageCropper = require("./libraries/booking-image-cropper/booking-image-cropper");
const charsCounter = require("./libraries/booking-chars-counter/booking-chars-counter");
const profileDescirptionUI = require("./libraries/booking-profile-description-ui/booking-profile-description-ui");
const autoPopup = require("./libraries/booking-autopopup/booking-autopopup");
// const incompleteForm = require("./libraries/booking-incomplete-form/booking-incomplete-form");
const sidebar = require("./sidebar");
const moredetails = require("./moredetails");

$(document).ready(function() {
  sidebar.onLoad();
  checkboxes.onLoad();
  imageUploader.onLoad();
  audioUploader.onLoad(profileMediaForm.performOnlyWhenConsentGiven);
  videoUploader.onLoad(profileMediaForm.performOnlyWhenConsentGiven);
  upsalesForm.onLoad();
  tooltips.onLoad();
  validations.onLoad();
  account.onLoad();
  horizontalSpinner.onLoad();
  priceAdjustment.onLoad();
  availabilityCalendar.onLoad();
  imageCropper.onLoad(function() {
    profileMediaForm.performOnlyWhenConsentGiven(imageUploader.uploadImages);
  }, profileMediaForm.performOnlyWhenConsentGiven);
  profileDescirptionUI.onLoad();
  profileMediaForm.onLoad([]);
  autoPopup.onLoad();
  charsCounter.onLoad();
  moredetails.onLoad();
});

// TODO: Discuss if the feature will be available
// If yes, populate it with other form elements.
if (window.location.toString().indexOf("prices") > 0) {
  // incompleteForm.onLoad();
}



// WEBPACK FOOTER //
// ./resources/js/app.js